// extracted by mini-css-extract-plugin
export default {"container":"Feedback_container__AVfzY","content":"Feedback_content__T9OuO","images":"Feedback_images__X6Rg6","footer":"Feedback_footer__zVkua"};